import { SearchItem } from '../../../../types/types';
import ResourceCard from '@/components/Card/Resource';
import { Card as ProgrammeCard } from '@/pages/mission/listing/components/programmes/components/card';
import { Card as MissionCard } from '@/pages/mission/listing/components/card';
import CourseCard from '@/components/Card/Course';

export type CardItemProps = {
  item: SearchItem;
};

function CardItem({ item }: CardItemProps) {
  switch (item?.__typename) {
    case 'Mission':
      return <MissionCard mission={item} />;
    case 'Programme':
      return <ProgrammeCard programme={item} seeMissionButtonText={'See Missions'} />;
    case 'Course':
      return <CourseCard course={item} />;
    case 'Resource':
      return <ResourceCard resource={item} />;
    default:
      return null;
  }
}

export { CardItem };
